import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How Men Who Stare At Goats gave me a breakthrough",
  "description": "",
  "published": "2010-02-26T00:00:00.000Z",
  "redirect_from": ["/blog/how-men-who-stare-at-goats-helped-gave-me-a-breakthrough/swizec/1191"],
  "categories": "Algorithm, Brain, food for thought, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night I was faced with a daunting task of making a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Metaheuristic",
        "title": "Metaheuristic"
      }}>{`meta-heuristic`}</a>{` process a non-trivial amount of data in no more than a tenth of the time it was taking now.`}</p>
    <p>{`Just to help you embrace the herculean task this was: My goal was to make the algorithm's runtime lower than 1.5 seconds for any realistic data sample. It was taking anywhere from 5 to 20 and even 30 seconds at the time.`}</p>
    <p>{`So I set off. First some profiling and some tidbits here and there, then tweaking and poking and yanking and scraping code for `}<em parentName="p">{`hours upon hours upon hours.`}</em></p>
    <p>{`Nothing, no increase in performance. Nothing even remote to sane behaviour at all. Even though the algorithm was working, my debugging/profiling data wasn't making any sense.`}</p>
    <p>{`And I said fuck this shit and went to chillax and rest my mind over `}<a parentName="p" {...{
        "href": "http://www.amazon.com/Men-Who-Stare-at-Goats/dp/0330375482%3FSubscriptionId%3D0G81C5DAZ03ZR9WH9X82%26tag%3Dzemanta-20%26linkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D0330375482",
        "title": "Men Who Stare at Goats"
      }}>{`Men Who Stare at Goats`}</a>{` for two hours.`}</p>
    <p>{`There were some good laughs and some pretty good chillaxing being done. My I-don't-know-which-exactly-or-what's-it-called part of the brain was probably busy processing the afore mentioned problem in the background. Or maybe it wasn't, who knows.`}</p>
    <p>{`All I know is that when I came back to the problem I noticed something funky.`}</p>
    <p>{`HEY THAT FUNCTION ARGUMENT SHOULDN'T BE A FUCKING CONSTANT WHAT THE FUCK IS GOING ON!`}</p>
    <p>{`Characters 1 and t look a lot alike ...`}</p>
    <p>{`So anyway, long story short. The meta-heuristic that used to take 1500 epochs to do something now takes only `}<em parentName="p"><strong parentName="em">{`ten`}</strong></em>{` to do the same thing, but slightly better.`}</p>
    <p>{`That's a pretty fucking good improovement right there!`}</p>
    <p>{`Now the algorithm is constantly taking about a second to do its thing and I'm happy. Pushed it into production where profiling data will be collected of a more varied sample of data to see if all is well.`}</p>
    <p>{`Chillaxing! It really does work.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/9b21d896-9c08-4f43-8180-2ccdffa12a70/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=9b21d896-9c08-4f43-8180-2ccdffa12a70",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      